import { H1 } from "../../../components/Heading";
import { Tabs } from "../../../components/Tabs";
import { MOBILE_BREAKPOINT } from "../../../config";
import styled from "../../../styles";
import { Billing } from "./Billing";
import { Integrations } from "./Integrations";
import { BrandProfile } from "./Profile";
import { BrandTeam } from "./Team";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0 ${(p) => p.theme.spacing.l};
  }
`;

export interface MatchParams {
  page: string;
}

export const BrandSettings = () => {
  return (
    <Wrap>
      <ContentWrap>
        <H1 margin="0 0 s">Settings</H1>
        <Tabs
          labels={[
            { label: "Integrations", hash: "integrations" },
            { label: "Team", hash: "team" },
            { label: "Profile", hash: "profile" },
            { label: "Billing" },
          ]}
          content={[
            <TabWrap>
              <Integrations />
            </TabWrap>,
            <TabWrap>
              <BrandTeam />
            </TabWrap>,
            <TabWrap>
              <BrandProfile />
            </TabWrap>,
            <TabWrap>
              <Billing />
            </TabWrap>,
          ]}
        />
      </ContentWrap>
    </Wrap>
  );
};

// to fix an issue where the card borders are cut off
const TabWrap = styled.div`
  margin: 1px;
`;

const ContentWrap = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: ${(p) => p.theme.spacing.xxl};
`;
